import { ThunkResult } from 'types';

import { fetchTags } from 'state/actions/tagActions';
import { fetchTopics } from 'state/actions/topicActions';
import { fetchGlobalSettings } from 'state/actions/globalSettingsActions';

export const initializeApplication = (): ThunkResult<void> => (dispatch) => {
  return dispatch({
    type: 'INITIALIZE_APPLICATION',
    payload: Promise.all([
      dispatch(fetchTags()),
      dispatch(fetchTopics()),
      dispatch(fetchGlobalSettings()),
    ]),
  });
};
